import React, { Component } from 'react'
import * as Subheader from '../services/Subheader'
import * as Service from '../services/Create'
import './Home.css'





export default class Usuarios extends Component {
  
        constructor(props) {
        super(props)
  
        this.state = {
            Header:  <Subheader.setHeader page="Usuarios" />,
            Form: <Service.Controller action="init" page="Usuarios" />,
            TableList: "",
           
        }
      
    
    }
    
    
    render() {
        
        return (
            
            <div className="container mt-5 text-start">
                <div className="row">
                    <div className='col-lg-6 col-sm-12'>
                    {this.state.Header}
                    </div>
                    <div className='col-lg-6 col-sm-12'>
                      {this.state.Form}
                    </div>

                    <div className='row'>
                    {this.state.TableList}
                    </div>
                </div>

                        
            </div>
           


        )
    }
}
